import React, { useState, useEffect } from "react";
import { Input, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import userServiceApi from "../../../api/userServiceApi";
import { getRequest } from "../../../api/http";
import { toast } from "react-toastify";
import { inputFieldCharLimit } from '../../../config/index'

const SearchAndFilter = ({ setFeedbackData, setLoading, reload, activeKey }) => {

    console.log('reload', reload)
     console.log('activeKey', activeKey)

    const [searchTerm, setSearchTerm] = useState('')

    const fetchAllData = async () => {
        try {
            setLoading(true);
            // const response = await getRequest(userServiceApi.getFeedbackSearch(searchTerm));
            const response = await getRequest(userServiceApi.getAllFeedbackWithRole(activeKey));
            if (response) {
                setFeedbackData(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error('Error fetching data')
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            fetchAllData();
        }, 500)
        return () => {
            clearTimeout(handler);
        };
    }, [reload, activeKey]);

    const fetchData = async () => {
        try {
            setLoading(true);
            // const response = await getRequest(userServiceApi.getFeedbackSearch(searchTerm));
            const response = await getRequest(userServiceApi.getFeedbackSearch(activeKey, searchTerm));
            if (response) {
                setFeedbackData(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error('Error fetching data')
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchTerm && searchTerm.trim() !== "") {
                fetchData();
            }
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);


    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }

    return (
        <div className="main-container" style={{ marginTop: 0 }} >
            <div className="filters-container">
                <div className="partner-heading"  ></div>
                <div className="buttons">
                    <div className="searchbar-containers">
                        <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
                            <Input
                                className="searchbar"
                                placeholder="Search Feedback"
                                value={searchTerm}
                                suffix={
                                    <SearchOutlined
                                        style={{ color: "#CC0E2D", verticalAlign: "middle" }}
                                    />
                                }
                                onPressEnter={(e) => handleSearchChange(e)}
                                onChange={handleSearchChange}
                                maxLength={inputFieldCharLimit}
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>)
}

export default SearchAndFilter